var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "suggested-moves",
      class: [{ invisible: _vm.$store.state.positionIndex <= 0 }]
    },
    [
      _c("div", { staticClass: "engine-actions" }, [
        _c(
          "a",
          {
            staticClass: "more-moves",
            attrs: { href: "javascript:" },
            on: { click: _vm.showMoreMoves }
          },
          [_vm._v(_vm._s(_vm.movesButtonText))]
        ),
        _c(
          "a",
          {
            staticClass: "more-depth",
            attrs: { href: "javascript:" },
            on: { click: _vm.higherDepth }
          },
          [_vm._v(_vm._s(_vm.depthButtonText))]
        )
      ]),
      _vm._m(0),
      _vm.analysisData
        ? _c(
            "div",
            { staticClass: "moves" },
            _vm._l(_vm.analysisData, function(variation) {
              return _c("div", { staticClass: "move-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "response-move",
                    on: {
                      click: function($event) {
                        _vm.$store.dispatch(
                          "analyzeCurrentPosition",
                          variation.index
                        )
                      }
                    }
                  },
                  [_vm._v(_vm._s(variation.move))]
                ),
                _c(
                  "div",
                  { staticClass: "evaluation", class: variation.color },
                  [_vm._v(_vm._s(variation.evaluation))]
                ),
                _c("div", { staticClass: "depth" }, [
                  _vm._v(_vm._s(variation.depth))
                ])
              ])
            })
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("div", { staticClass: "response-move" }, [_vm._v("Response")]),
      _c("div", { staticClass: "evaluation" }, [_vm._v("Score")]),
      _c("div", { staticClass: "depth" }, [_vm._v("Depth")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e437d564", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e437d564","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/analysis_info.vue
// module id = 237
// module chunks = 0